import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { generateLinkStyleFromTheme, TextLinkComponent } from '../../../partials/link/TextLink';
import { useTheme } from '../../../../theming/useTheme';
import { MEDIA_BREAKPOINTS } from '../../../../mediaQueries.const';
import { P, semanticCSS } from '../../../../typography/semanticTags';
import { BaseUnit } from '../../../../theming/baseUnitDefinition';

const componentConfigurationKey = 'bottomFooterBar';

interface BottomFooterBarThemeProps {
  backgroundColor: string,
  baseUnit: BaseUnit
  textColor: string
}

export interface BottomFooterBarDataProps {
  year: number,
  rightsReservedText: string,
  poweredByLink: {
    text: string,
    href: string
  }
}

type BottomFooterBarProps = BottomFooterBarDataProps & BottomFooterBarThemeProps;

const getBottomFooterBarStyle = ({ backgroundColor, baseUnit, textColor }: BottomFooterBarThemeProps) => StyleSheet.create({
  style: {
    backgroundColor,
    color: textColor,
    padding: `${baseUnit * 0.5}px`,
    [MEDIA_BREAKPOINTS.MEDIUM]: {
      textAlign: 'center',
    },
    [MEDIA_BREAKPOINTS.SMALL]: {
      textAlign: 'center',
    },
  },
});

export const BottomFooterBarComponent: React.FunctionComponent<BottomFooterBarProps> = props => {
  const bottomFooterBarStyle = getBottomFooterBarStyle(props);
  const { textColor, year, rightsReservedText, poweredByLink } = props;
  const linkStyle = generateLinkStyleFromTheme({ idleColor: textColor, activeStateColor: textColor, hoverStateColor: textColor });

  return (
    <P styles={semanticCSS(bottomFooterBarStyle.style)}>
      <TextLinkComponent href={poweredByLink.href} linkStyle={linkStyle} rel="noopener" target="_blank">
        {poweredByLink.text}
      </TextLinkComponent>
      {` © ${year} ${rightsReservedText}`}
    </P>
  );
};

const mapThemeProps = (theme: BottomFooterBarThemeProps) => {
  return {
    backgroundColor: theme.backgroundColor,
    baseUnit: theme.baseUnit,
    textColor: theme.textColor,
  };
};

export const BottomFooterBar = (props: BottomFooterBarDataProps) => {
  const themeContext = useTheme(mapThemeProps, componentConfigurationKey);
  return <BottomFooterBarComponent {...themeContext} {...props} />;
};
